export default {
  editPermissions: 'Ustaw uprawnienia',
  safePassword: {
    summary: 'Skopiuj hasło początkowe',
    details: 'Poniższe hasło początkowe jest wyświetlane tylko raz. Prosimy o jego zanotowanie i przekazanie nowemu użytkownikowi. Po pierwszym zalogowaniu użytkownik zostanie poproszony o ustawienie stałego hasła',
  },
  title: 'Utwórz nowego użytkownika',
};
